import React from "react";

export default function ProfileImgModal({ cancelModal, image }) {
  const handleOverlayClick = (e) => {
    if (e.target.className.includes("img-modal-overlay")) {
      cancelModal();
    }
  };

  return (
    <div
      className="img-modal-overlay position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-90"
      style={{ zIndex: 1055 }}
      onClick={handleOverlayClick}
    >
      <div className="position-relative">
        <button
          className="btn btn-light position-absolute top-0 end-0 translate-middle rounded-circle p-0 d-flex align-items-center justify-content-center"
          style={{ width: "2.5rem", height: "2.5rem" }}
          onClick={cancelModal}
          aria-label="Close"
        >
          &times;
        </button>
        <img onClick={cancelModal}
          src={image}
          alt="Enlarged preview"
          className="img-fluid rounded shadow"
        />
      </div>
    </div>
  );}